var ModalLogin = function () {

    this.init = function () {
        
        $('#login-form').css('display', 'none');
        $('#esqueci-senha-form').css('display', 'none');
        $('#esqueci-senha-confirmacao').css('display', 'none');
        $('#cadastro-form').css('display', 'none');
        $('#cadastro-confirmacao').css('display', 'none');
        $('#perfil-form').css('display', 'none');
        $("#perfil-confirmacao").css("display", "none");

		$('.btn-edit-perfil').click(function(e){
			
			e.preventDefault();
			$('#modal-login').css('display', 'none');
			$('#perfil-form').css('display', 'block');

			$('.loader').show();

			$.ajax({
				type: "GET",
				url: "/umbraco/surface/members/getmemberlogged",
				async: true,
				contentType: "application/json; charset=utf-8",
				success: function success(response) {
					$('.loader').hide();
	
					if(response){
						$('#perfil-form').find('#nome').val(response.data.Name);
						$('#perfil-form').find('#email').val(response.data.Email);
						$('#perfil-form').find('#empresa').val(response.data.Company);
						$('#perfil-form').find('#segmento').val(response.data.Segment);
						$('#perfil-form').find('#funcionarios').val(response.data.NumberOfEmployees);
					}else{
						$("#perfil-form").css("display", "none");
						$('#modal-login').css('display', 'block');
					}
					
				},
				error: function error(e) {
					$("#perfil-form").find(".error").text("Ocorreu um erro, tente novamente mais tarde.");
				},
				complete: function () {
				
				}
			});
		});

        if($('#modal-header').find('#isMemberLogged').val() == "true"){
            $('#modal-login').css('display', 'none');
            $('#perfil-form').css('display', 'block');
        }

        $('#btn-login-modal').click(function(){
            $('#modal-login').css('display', 'none');
            $('#login-form').css('display', 'block');
        });

        $('#btn-cadastro-modal').click(function(){
            $('#modal-login').css('display', 'none');
            $('#cadastro-form').css('display', 'block');
        });

        $('.btn-esqueci-senha').click(function(){
            $('#modal-login').css('display', 'none');
            $('#login-form').css('display', 'none');
            $('#esqueci-senha-form').css('display', 'block');
        });

        $('#btn-esqueci-senha').click(function(){
            $('#esqueci-senha-form').css('display', 'none');
            $('#esqueci-senha-confirmacao').css('display', 'block');
        });

        $('#btn-cadastro-modal').click(function(){
            $('#modal-login').css('display', 'none');
            $('#cadastro-form').css('display', 'block');
        });

        
		$('.btn-login').on('click', function () {
			var obj = $(this)
            $('#login-form').css('display', 'none');
			$('#esqueci-senha-form').css('display', 'none');
			$('#esqueci-senha-confirmacao').css('display', 'none');
			$('#cadastro-form').css('display', 'none');
            $('#cadastro-confirmacao').css('display', 'none');
            $('#perfil-form').css('display', 'none');
            $("#perfil-confirmacao").css("display", "none");

            if($('#modal-header').find('#isMemberLogged').val() == "true"){
				if(obj.hasClass('btn-login-mobile')){
					$('.submenu-perfil').slideToggle();
				}else{
					$('.tooltip-modal').slideToggle();
				}
				return false;
            }else{
                $('#modal-login').css('display', 'block');
            }
		});
        


    }
    
    return this.init();
}